import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/voucher/file-imports?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/voucher/file-imports/${id}`, { params });
}

export async function create(body) {
  return request(`/voucher/file-imports`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/voucher/file-imports/${id}`, {
    method: 'POST',
    body,
  });
}